function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../locales/keys';
import { find, propEq } from 'ramda';
import { AdditionalPropValueType, MetadataConstants, MetadataHelpers, MetadataSelectors, CoreLocaleKeys } from 'invision-core';
import { setEditAdditionalProperty, setEditApOnChange } from '../../../reducers/actions/customer.actions';
import { SubscriberAdditionalPropertiesSelector } from './additional.properties.filtered.selector';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    additionalPropertyLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdditionalProperty, store),
    additionalPropertyValueLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdditionalPropertyValue, store),
    subscriberAdditionalPropData: SubscriberAdditionalPropertiesSelector(store),
    regularExpressionLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.RegularExpression, store),
    additionalPropValueSelector: MetadataSelectors.codes.MetadataCodeTypeIntegerSelector(MetadataConstants.codes.AdditionalPropertyValue, store)
  };
};
var AdditionalPropertiesSectionController = /*#__PURE__*/function () {
  function AdditionalPropertiesSectionController($ngRedux) {
    _classCallCheck(this, AdditionalPropertiesSectionController);
    this.$ngRedux = $ngRedux;
  }
  return _createClass(AdditionalPropertiesSectionController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        setEditAdditionalProperty: setEditAdditionalProperty,
        setEditApOnChange: setEditApOnChange
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.actions.setEditAdditionalProperty(this.state.subscriberAdditionalPropData);
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
      this.CoreLocaleKeys = CoreLocaleKeys;
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "onListUpdated",
    value: function onListUpdated() {
      this.actions.setEditAdditionalProperty(this.state.subscriberAdditionalPropData);
    }
  }, {
    key: "onAddlPropertyChange",
    value: function onAddlPropertyChange(id, newValue) {
      var findType = find(propEq(id, 'id'))(this.state.subscriberAdditionalPropData);
      switch (findType.type) {
        case AdditionalPropValueType.SINGLE_TEXT:
          this.actions.setEditApOnChange(id, [newValue]);
          this.onPropertyChange()(this.customerModel);
          break;
        case AdditionalPropValueType.MULTIPLE_TEXT:
          this.actions.setEditApOnChange(id, newValue);
          this.onPropertyChange()(this.customerModel);
          break;
        case AdditionalPropValueType.SELECT:
        case AdditionalPropValueType.BOOLEAN:
          newValue = newValue ? [MetadataHelpers.codes.getNameForCode(this.state.additionalPropValueSelector, newValue)] : [];
          this.actions.setEditApOnChange(id, newValue);
          this.onPropertyChange()(this.customerModel);
          break;
        default:
          break;
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./additional.properties.section.html'),
  bindings: {
    customerModel: '<',
    onFormChanged: '&',
    onPropertyChange: '&',
    errorLookup: '<',
    isFormSubmitted: '<',
    markMandatoryCreditCheckFieldsDisabled: '<?',
    overrideValidations: '<?',
    removeMultiOfferValidations: '<?'
  },
  controller: AdditionalPropertiesSectionController,
  controllerAs: 'AdditionalPropertiesSection'
};